/*
ABOUT >>
THIS INPUT USED FOR MAKE LIST FULLY DYNAMIC  

ACTIVE >>
ITS IN RUNNING POSITION 

UPDATES >>
IT WILL BE UPDATE TO MAKE MORE ENHANCE CODE AND WHEN LOAD THEN NOT PASSING VALUES OR FUNCTIONS TO PARENT 
*/

import React, { useEffect,  useRef, useState, useMemo } from 'react';
import './dynamic-v-5.scss';
// import { decryptData } from "../decryption/decryption";

import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import HardDelete from '../hard-delete/hard-delete';
import AuditTableInput from '../audit-table/audit-table'
import SecureComponent from '../security/secure.component';
import SecurityService from '../security/security.service';
import IrtizDynamicInputAdd from './mainSection-popup-add-v-5';
import DialogInput from './list-button-popup-list-v-5';
import TemplateCode from '../template-code/template-code';
import { useDispatch, useSelector } from 'react-redux';
import { gridColumnsList ,gridGroupingOptions} from '../../store/slices/list-tempate';
import moment from 'moment';
import { setTitle } from '../../store/slices/head';

// import accessoryBOMService from './irtiza-dynamic-input.service';

import  imgSrc from './spinner.gif';
// indexedDB.js


// Open (or create) the database
// const dbPromise = openDB('my-database', 1, {
//   upgrade(db) {
//     // Create a store for process descriptions
//     db.createObjectStore('Brand', { keyPath: 'BrandID' });
//   },
// });

// // Retrieve all data from IndexedDB
//  const getFromDB = async (id) => {
//   const db = await dbPromise;
//   return db.getAll(id);
// };

// // Save an array of objects to IndexedDB


// const saveToDB = async (data) => {
//   const db = await dbPromise;
//   console.log(data)
//   return db.put('Brand', {data });
// };

// const dbPromise = openDB('my-database', 5, {
//   upgrade(db) {
//     // Create a store for process descriptions
//     if (!db.objectStoreNames.contains('Brand')) {
//       db.createObjectStore('Brand', { autoIncrement: true });
//     }
//     if (!db.objectStoreNames.contains('InvoicePurchaseDetail')) {
//       db.createObjectStore('InvoicePurchaseDetail', { autoIncrement: true });
//     }
//     if (!db.objectStoreNames.contains('InvoiceSaleDetail')) {
//       db.createObjectStore('InvoiceSaleDetail', { autoIncrement: true });
//     }
//     if (!db.objectStoreNames.contains('InvoicePurchaseSummary')) {
//       db.createObjectStore('InvoicePurchaseSummary', { autoIncrement: true });
//     }
//     if (!db.objectStoreNames.contains('InvoiceSaleSummary')) {
//       db.createObjectStore('InvoiceSaleSummary', { autoIncrement: true });
//     }
   
//   },
// });

// // Retrieve all data from IndexedDB
// const getFromDB = async (storeName) => {
//   const db = await dbPromise;
//   const tx = db.transaction(storeName, 'readonly');
//   const store = tx.objectStore(storeName);
//   return store.getAll();
// };

// const saveToDB = async (id, data, batchSize = 100) => {
//   const db = await dbPromise;
  
//   for (let i = 0; i < data.length; i += batchSize) {
//     const batch = data.slice(i, i + batchSize);
//     const tx = db.transaction(id, 'readwrite');
//     const store = tx.objectStore(id);

//     for (const item of batch) {
//       await store.put(item);
//     }

//     await tx.done;
//   }

//   console.log('Data saved successfully in batches!');
// };

// Save an array of objects to IndexedDB
// const saveToDB = async (id , data) => {
//   const db = await dbPromise;
//   const tx = db.transaction(id, 'readwrite');
//   const store = tx.objectStore(id);
//   console.log(id)
//   console.log(data)
//   // Iterate over the array and save each item individually
//   // for (const item of data) {
//   //   console.log(item)
//   //   await store.put(item);
//   // }
//   data.forEach(async (item) => {
//     console.log(item);
//     await store.put(item);
//   });

//   // await store.put({ id: id, data: JSON.stringify(data) });

//   await tx.done; // Ensure the transaction is complete before returning
//   console.log('Data saved successfully!');
// };
// const saveToDB = async (data) => {
//   const db = await dbPromise;
//   const tx = db.transaction('processDesc', 'readwrite');
//   const store = tx.objectStore('processDesc');
//   console.log(db)
//   console.log(tx)
//   console.log(store)
//   // Clear existing data
//   await store.clear()
//   store.put([
//     {BrandID:1,BrandName:'IRTIZA'},
//     {BrandID:2,BrandName:'IRTIZA JASS'}
//   ])
  
  // Put each item in the store
  // for (const item of data) {
  //   await store.put(item);
  // }

//   await tx.done;
// };

// Clear data from IndexedDB
//  const clearDB = async () => {
//   const db = await dbPromise;
//   return db.clear('processDesc');
// };


let selectedRows = []
let dataListData =[]

const STEPS = 101; // Number of records to load in each step
let CHUNK_SIZE = 0; // Number of records to load in each step
const INTERVAL = 2000; 
export default function AccessoryBOMList(
  {
  Id='Dynamic',
  ListTitle = '',
  ColumnsList = [],
  GridDataSource = [],
  DefaultSortedColumnName='',
  GridDialog = [],
  ListActionComplete,
  
  // OPTIONAL
  ListDelete=[],
  DeleteType='Hard',
  AllowTemplate=true,
  ToolbarOption= 'All',
  ToolbarClicking,
  AllowGrouping=true,
  AllowExcelExport=true,
  AllowPdfExport=true,
  ShowColumnChooser=true,
  AllowPaging=true,
  AllowDataBound=false,
  ListSecurity='',
  AddSecurity='',
  EditSecurity='',
  DeleteSecurity='',
  ViewSecurity='',
  DefaultSortedColumnSort='Descending',
  FilterColumns=[],
  GroupColumns=[],
  GridEditSettingHeaderTemplate='<p></p>',
  GridEditSettingMode='Dialog',
  GridSumColumns=[],
  AllowGridSum=false,
  IsDialog=false,
  HeadTitle='',
  rowDataBound=undefined,

 }) {
    const grids = useRef({});
  
  const formatOptions = { type: 'date', format: 'dd/MM/yy' }
  function addUnderscore(input) {
    return input.replace(/([a-z])([A-Z])/g, '$1_$2');
}

  // InvoiceEvaluationID	
  // InvoiceNo	
  // MainInvoiceID	
  // CurrencyName	
  // CurrencyID	
  // ExchangeRate	
  // HawalaCommissionPercent	
  // CurrencyNameHawala	
  // CurrencyIDHawala	
  // AccountTitleHawalaDr	
  // AccountIDHawalaDr	
  // AccountTitleHawalaCr	
  // AccountIDHawalaCr
//   ColumnsList.forEach(column => {
//     if (column.field.endsWith('Date')) {
//         column.other.push({ 'format': formatOptions });
//     }
// });
//
// if(ColumnsList.length > 0){
  
  
//   ColumnsList = [...ColumnsList];
  
//   let dateIndex = ColumnsList.findIndex(res => res.field.endsWith('Date'));
//   if (dateIndex !== -1) {
//     
//     
//     ColumnsList[dateIndex].other = [ { 'format': formatOptions }]
//     }
//     }
//   
//   var ColumnProps =  ColumnsList

// let Columns = [...ColumnsList];


//       // 
//       var ColumnProps =  ColumnsList
      // if (column.field.endsWith('Date')) {
      //     column.other.push({ 'format': formatOptions });
      // }
    

  
  // InputL ist Security Name
//   let InputListSecurity = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'AccessoryBOMList' : 'AccessoryBOMDetailList';
// let defaultSortColumnName = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'AccessoryBOMID' : 'AccessoryBOMDetailID'
// let defaultSortColumnType =  'Descending'
// let InputNameForPdfExcelExport = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'Accessory BOM - LIST' : 'Accessory BOM DETAIL - LIST'
// let exportFileName = props?.location?.pathname.split('/')[3] == 'Summary'  ? 'accessory_bom' : 'accessory_bom_detail'
let InputListSecurity = ListSecurity == '' ? `${Id}List`:ListSecurity;

let defaultSortColumnName = DefaultSortedColumnName
let defaultSortColumnType =  DefaultSortedColumnSort
let InputNameForPdfExcelExport = ListTitle
let exportFileName = addUnderscore(Id)

 //  DYNAMIC CODE 
 const dispatch = useDispatch()
 const reduxData = useSelector(state =>{return state.listTemplate})
console.log(reduxData)
//  let grids.current[Id]: Grid;
 var filterColumnName = []
 var recordColumnName = []
 var fiterCheckedValue = []
  const [dataSourceState, setDataSourceState] = useState([]);
  const [loadingdataSourceState, setLoadingDataSourceState] = useState(false);

  const [filterState, setFilterState] = useState([]);
  
  const [groupState, setGroupState] = useState([]);
  
  const [deletingProps, setDeletingProps] = useState();
  const [showDialogs, setShowDialogs] = useState(false);

  const [selectedRow, setSelectedRow] = useState([]);

  const [columnData, setColumnData] = useState([]);

  let popupModeTypeView = false;
  // var ColumnProps =   []
  useEffect(() => {
    // grids.current[Id]?.dataBound(grids.current[Id]?.autoFitColumns()) ;
    const transformedFilters = FilterColumns.map(col => ({
      field: col.field,
      operator: col.operator ? col.operator : 'equal',
      value: col.value.toString() // Ensure the value is a string
  }));
  
  setFilterState(transformedFilters);

    const updatedColumns = ColumnsList.map(column => {
      console.log(column)
      if (column?.field && column?.field.endsWith('Date')) {
          return {
              ...column,
              other: [{...column.other[0],  'format': formatOptions }]
          };
      }else if(         column?.field.toLowerCase().startsWith('isdeleted') || column?.field.toLowerCase().startsWith('isapproved') || column?.field.toLowerCase().startsWith('isclosed')  || column?.field.toLowerCase().startsWith('is') ) {
        return {
          ...column,
          other: [{...column.other[0],  template:(props) => {
            return (
            <p style={{margin: '0px'}}>
                               {props[column.field] === true ? 'Yes' :props[column.field] === false ? 'No': props[column.field]}

              </p>
            )
            }   }]
      };
      }
      // else if ( column.field == 'Commands' && column.other[0]?.button && column.other[0]?.button.length > 0) {
      //   const commands = column.other[0].button.map(btn => ({
      //     buttonOption: {
      //       id: btn.id,
      //       content: btn.content,
      //       cssClass: 'e-flat',
      //       isPrimary: true
      //     }
      //   }));
    
      //   // Return the column with the dynamically generated commands array
      //   return {
      //     ...column,
      //      other: [{ ...column.other[0],commands: commands }]
      //   };
      // }
      
      
      
      
      return column;
  });


   
// var ColumnProps = updatedColumns
console.log(updatedColumns)
setColumnData(updatedColumns)

   if(IsDialog == false){   dispatch(gridColumnsList(updatedColumns))}
    setGroupState(GroupColumns)
    dispatch(gridGroupingOptions(  
      {
           showDropArea: true,
         // showGroupedColumn: false,
         //   columns:[]// Group by FinishSize and ProductDesc
       
           columns:GroupColumns || [] 
         }))
    
    getListService();
    setTimeout(() => {
      
    }, 1000);

  }, []);
  useEffect(() => {
    dispatch(setTitle(HeadTitle != '' ? HeadTitle : ListTitle))

  }, []);

// DYNAMIC TEMPLATE CODE
const [isToggled, setIsToggled] = useState(false);
const [ToggledValue, setToggledValue] = useState( 'Hide Template');
useEffect(() => {
  setTimeout(() => {
    setToggledValue(isToggled == true? 'Hide Template' : 'Show Template')
  }, 100);
}, [isToggled]);

    // let dialogInstance: DialogComponent;
    // const toolbar: ToolbarItems[] = ['PDFExport'];
  const toolbarClick = (args: ClickEventArgs) => {
    console.log(args)
    popupModeTypeView = false
    let reportName = document.getElementById('reportName')?.value;
    let getOrientation = document.getElementsByClassName('orientation')
    let selectedOrientation = getOrientation[0]?.checked ==  true ? 'Portrait':'Landscape'
    let getHeaderCheck = document.getElementsByClassName('headerCheck')[0]?.checked;
    let headerCheck =  !getHeaderCheck
    if ( grids.current[Id] && args.item.properties.id === `${Id}Grid_PDFExport` ) {
      
      
      if(headerCheck == true && AllowTemplate == true){
        let ress = filterColumnName.map((res, index) => {
          // Convert camelCase to Title Case and uppercase all letters
          let title = res.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase();
          // Calculate position dynamically
          let position = { x: 10, y: 120 + (index * 40) };
          // Define style properties
          let style = { textBrushColor: "#000000", fontSize: 12, hAlign: 'Center' };
          // Join checked values with separator '|'
          let checkedValues = fiterCheckedValue[index].join(' | ');
          
          return {
              position: position,
              style: style,
              type: "Text",
              value: `${title}: ${checkedValues},`
          };
      });
      // let filteredColumnss = [...grids.current[Id].columns];
      // let filteredColumns = filteredColumnss.filter(col => col.headerText !== 'Commands');

  const exportProperties: PdfExportProperties = {
          header: { 
          contents: [ 
            // {
            //   position: { x: 10, y: 30 },
            //   size: { width: 120, height: 80 }, // Set the width and height of the image
            //   type: "Image",
            //   src:''
            // },
            { 
              position: { x:selectedOrientation == 'Landscape' ?420:260 , y: 50 }, 
              style: { textBrushColor: "#000000", fontSize: 20, hAlign:'Center' }, 
              type: "Text", 
              value: `DALAL INDUSTRIES`
              
            },
            { 
              position: { x:selectedOrientation == 'Landscape' ?410:270 , y: 80 }, 
              style: { textBrushColor: "#000000", fontSize: 16, hAlign:'Center' }, 
              type: "Text", 
              value: reportName.toUpperCase() ? reportName.toUpperCase() : InputNameForPdfExcelExport
              },  
            ...ress
          
          ]
           ,
           fromTop: 0, 
            height: 230 
        },
         footer: {
                    contents: [
                        {
                            format: 'Page {$current} of {$total}',
                            pageNumberType: 'Northwind Traders',
                            position: { x: selectedOrientation == 'Landscape' ?930:600, y: 25 },
                            style: {
                                fontSize: 16,
                                textBrushColor: '#000000'
                              },
                              type: 'PageNumber'
                            },
                            { 
                              position: { x:selectedOrientation == 'Landscape' ?20:10 , y: 25 }, 
                              style: { textBrushColor: "#000000", fontSize: 16, hAlign:'Center' }, 
                              type: "Text", 
                              value: `DATE: ${ moment().format('DD-MM-YYYY HH:mm:ss')}`
                            },
                            { 
                              position: { x:selectedOrientation == 'Landscape' ?420:320 , y: 25 }, 
                              style: { textBrushColor: "#000000", fontSize: 16, hAlign:'Center' }, 
                              type: "Text", 
                              value: `Printed By: ${reduxData.printedByUserName}`
                              }
                          ],
                          fromBottom: 20,
                          height: 60
                },
        pageOrientation: selectedOrientation,
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.pdf`,
        // columns: filteredColumns // Pass the full column definitions

      };
      
      setTimeout(() => {
        
        return grids.current[Id].pdfExport(exportProperties); 
      }, 500);
}else{
  console.log(args)
  console.log(grids.current[Id].columns);

  // Filter out the "Commands" column and keep the full column definitions
  // let filteredColumns = grids.current[Id].columns.filter(col => col.headerText !== 'Commands');
  // console.log(filteredColumns);
  
  const withOutHeaderexportProperties: PdfExportProperties = {
    pageOrientation: selectedOrientation,
    fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.pdf`,
    // columns: filteredColumns // Pass the full column definitions
  };
  
  grids.current[Id].pdfExport(withOutHeaderexportProperties);
  
  
}
    
    }
    if (
      grids.current[Id] &&
      args.item.properties.id === `${Id}Grid_excelexport`
    ) {
      if(headerCheck == true &&  AllowTemplate == true){
      let excelress =   filterColumnName.map((res,ind)=>{
        let title = res.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase()
        // let len = fiterCheckedValue.length()
       return { cells: [{ colSpan: 6, value: `${ title} :  ${fiterCheckedValue[ind].join(',')}` , style: {  fontSize: 12,hAlign: 'Left', }} ]}
      
      })
      // let filteredColumns = grids.current[Id].columns.filter(col => col.headerText !== 'Commands');

      const exportProperties: ExcelExportProperties = {
        
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.xlsx`,
        footer: {
          footerRows: 2,
          rows: [
              { cells: [{ colSpan: 4, value: `Printed By: ${reduxData.printedByUserName}`, style: { hAlign: 'Center', bold: true } }] },
              
          ]
      },
      header: {
          headerRows: 4 + fiterCheckedValue.length,
          rows: [
              { cells: [{ colSpan: 2, value: "", style: {  fontSize: 20, hAlign: 'Center', bold: true, } }] },
              { cells: [{ colSpan: 4, value: "DALAL INDUSTRIES", style: {  fontSize: 25, hAlign: 'Center', bold: true, } }] },
              { cells: [{ colSpan: 4, value:reportName.toUpperCase() ? reportName.toUpperCase():'PRODUCT FINISH SIZE - LIST', style: { fontSize: 15, hAlign: 'Center', bold: true, } }] },
              { cells: [{ colSpan: 4, value: `DATE: ${ moment().format('DD-MM-YYYY HH:mm:ss')}` , style: {  fontSize: 12,hAlign: 'Right' } }] },
              ...excelress
          ]
      },
      // columns: filteredColumns // Pass the full column definitions

      };
      grids.current[Id].excelExport(exportProperties);
     }else{
      // let filteredColumns = grids.current[Id].columns.filter(col => col.headerText !== 'Commands');
    //   grids.current[Id].columns.forEach(col => {
    //     if(col.headerText == 'Commands'){
    //     col.visible = false;
    //     }
    //     return col
    // });
    
console.log(grids.current[Id].columns)
// console.log(filteredColumns)
      const exportProperties: PdfExportProperties = {
        pageOrientation: selectedOrientation,
        fileName: `${moment().format('YYYYMMDD')}_${exportFileName}.xlsx`,
        // columns:grids.current[Id].columns
        // columns: filteredColumns // Pass the full column definitions

      };
      grids.current[Id].excelExport(exportProperties);
    }
    }
    if (
      grids.current[Id] &&
      args.item.properties.id === `${Id}Grid_columnchooser`
    ) {
    }
    if (grids.current[Id] && args.item.properties.id === 'Delete' ) {
      
      if (grids.current[Id].selectedRowIndex === -1) {
        // no rows selected
        
        // setDialogWarningVisibility(false);
        let obj={
          RowID:undefined,
          SelectedRow:false
          
        }
        setDeletingProps(obj)
        setShowDialogs(true)

      } else {
        ToolbarClicking(grids.current[Id], args ,grids.current[Id].getSelectedRecords()[0]  , getListService,setDataSourceState)

        if(ListDelete.length == 0){
          
          let GridObj = {...grids.current[Id].getSelectedRecords()[0]};
        for (let key in GridObj) {
          if (GridObj.hasOwnProperty(key)) {
            const dateKeys = ['ApprovedByDate', 'CreationDate', 'UpdationDate', 'DeletionDate'];
            const booleanKeys = ['IsDeleted', 'IsClosed', 'IsApproved'];
            if(key.endsWith('ID') || key.includes('ID') || booleanKeys.includes(key) || dateKeys.includes(key) ){
              
              delete GridObj[key]
            }else{
              if(key.includes('Date')){
                if(GridObj[key] instanceof Date){
                  GridObj[key] = moment(GridObj[key]).format('DD-MMM-YY')
                }
              }else if(key.includes('Rate')){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(2)
              
              }else if(!isNaN( GridObj[key])){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(1)
              }else{
                GridObj[key] = GridObj[key]
              }

            }
          }
          
        }
        
        // deleteDialog.current.hide();
        let obj={
          TableName:Id,
          ColumnName:DefaultSortedColumnName,
          // DeleteSecurity:ListDelete[0]?.DeleteSecurity ?  ListDelete[0].DeleteSecurity : undefined,
          RowID:grids.current[Id].getSelectedRecords()[0][DefaultSortedColumnName],
          SelectedRow:true,
          UserID:userId,
          SelectedRowData:GridObj
            }
            if(DeleteType == 'Soft'){
              obj.DeleteSecurity = `${Id}Delete`
              }
            
          setDeletingProps(obj)
        setShowDialogs(true)
        setTimeout(() => {
          
        }, 8000);

        }else{
          ToolbarClicking(grids.current[Id], args ,grids.current[Id].getSelectedRecords()[0],getListService ,setDataSourceState)

        
        let GridObj = {...grids.current[Id].getSelectedRecords()[0]};
        for (let key in GridObj) {
          if (GridObj.hasOwnProperty(key)) {
            const dateKeys = ['ApprovedByDate', 'CreationDate', 'UpdationDate', 'DeletionDate'];
            const booleanKeys = ['IsDeleted', 'IsClosed', 'IsApproved'];
            if(key.endsWith('ID') || key.includes('ID') || booleanKeys.includes(key) || dateKeys.includes(key) ){
              
              delete GridObj[key]
            }else{
              if(key.includes('Date')){
                if(GridObj[key] instanceof Date){
                  GridObj[key] = moment(GridObj[key]).format('DD-MMM-YY')
                  
                  
                }
              }else if(key.includes('Rate')){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(2)
              
              }else if(!isNaN( GridObj[key])){
                GridObj[key] = parseFloat( GridObj[key]).toFixed(1)
              }else{
                GridObj[key] = GridObj[key]
              }

            }
          }
          
        }
        
        // deleteDialog.current.hide();
        let obj={
          // TableName:ListDelete[0].TableName,
          // ColumnName:ListDelete[0].TableID,
          // // DeleteSecurity:ListDelete[0]?.DeleteSecurity ?  ListDelete[0].DeleteSecurity : undefined,
          // RowID:grids.current[Id].getSelectedRecords()[0][ListDelete[0].TableID],
          // SelectedRow:true,
          TableName:ListDelete[0].TableName,
          ColumnName:ListDelete[0].TableID,
          // DeleteSecurity:ListDelete[0]?.DeleteSecurity ?  ListDelete[0].DeleteSecurity : undefined,
          RowID:Array.isArray(ListDelete[0].TableID) ?  ListDelete[0].TableID.map(id => selectedRows[id]): selectedRows[ListDelete[0].TableID],
          SelectedRow:true,
          UserID:userId,
          SelectedRowData:GridObj
            }
            if(ListDelete[0]?.TableSecurity){
              obj.DeleteSecurity = ListDelete[0]?.TableSecurity
              }
            
          setDeletingProps(obj)

          setShowDialogs(true);
        setTimeout(() => {
          
        }, 8000);

      }
    } 
    } else
    if (grids.current[Id] && args.item.properties.id) {
      console.log(args.item.properties)
      if(args.item?.mustSelectRow == true){
        if(grids.current[Id].selectedRowIndex === -1){
          // let key=exportContractGrid.getSelectedRecords()[0]?.ExportContractID;
          // handleRedirectPlanning(key)
          let obj={
    
          }
          setDeletingProps(obj)
              setShowDialogs(true)
    
      }else{
        ToolbarClicking(grids.current[Id], args ,grids.current[Id].getSelectedRecords()[0],getListService ,setDataSourceState)

      }
      }else{
        ToolbarClicking(grids.current[Id], args ,grids.current[Id].getSelectedRecords()[0],getListService ,setDataSourceState)
        
      }
      
  }

  if (args.item.properties.id === 'Edit') {
    if (grids.current[Id].selectedRowIndex == -1) {
      let obj={
        RowID:undefined,
        SelectedRow:false
        
      }
      setDeletingProps(obj)
      setShowDialogs(true)
    }else{
      grids.current[Id].startEdit();

    }
  }
  if (args.item.properties.id === 'View') {
    console.log(args)
    console.log(args.item.properties)
    console.log(grids.current[Id].selectedRowIndex)
    if (grids.current[Id].selectedRowIndex == -1) {
      // window.alert('Please select a row to view');
      // return;
      let obj={
        RowID:undefined,
        SelectedRow:false
        
      }
      setDeletingProps(obj)
      setShowDialogs(true)
    }else{
      // Get row index of selected record
      //  const rowIndex = grids.current[Id].getRowIndexByPrimaryKey(selectedRows.id); 
      //  if (rowIndex !== -1) {
        // Trigger the same popup used in edit mode
        popupModeTypeView = true
        grids.current[Id].startEdit();
 
  // };
    }
    }

  }

  const [processDesc, setProcessDesc] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const allRecordsRef = useRef([]); // Use a ref to store allRecords
  const intervalIdRef = useRef(null); // Use a ref to store the interval ID

  const findValidStepValue = (totalRecords, maxSteps) => {
    for (let steps = 4; steps <= maxSteps; steps++) {
      const chunkSize = Math.floor(totalRecords / steps);
      if (totalRecords % steps === 0) {
        return { steps, chunkSize };
      }
    }
    return { steps: 1, chunkSize: totalRecords }; // Fallback if no valid step found
  };
  const loadMoreRecords = () => {
    const allRecords = allRecordsRef.current; // Access allRecords from the ref
    console.log('All Records:', allRecords);
    const endIndex = Math.min(currentIndex + CHUNK_SIZE, allRecords.length);
    
    setDataSourceState(
      // ...allRecords.slice(currentIndex, currentIndex + CHUNK_SIZE),
    allRecords
    );
    clearInterval(intervalIdRef.current)
    // setDataSourceState((prevRecords) => [
    //   ...prevRecords,
    //   // ...allRecords.slice(currentIndex, currentIndex + CHUNK_SIZE),
    //   ...allRecords.slice(currentIndex, endIndex),
    // ]);
    setCurrentIndex((prevIndex) => {
      const newIndex = prevIndex + CHUNK_SIZE;
      
      // Clear the interval once all records are loaded
      if (newIndex >= allRecords.length) {
        clearInterval(intervalIdRef.current);
      }
      
      return newIndex;
    });
  };


  const getListService = async () => {
  let  DataSourceType = GridDataSource[0]?.DataSourceType || 'Function'
    if (DataSourceType === 'Function') {
      try {
        // const cachedData = await getFromDB(GridDataSource[0].DataSourceIndexName ? GridDataSource[0].DataSourceIndexName  : Id);
        // // const cachedData = await getFromDB('InvoicePurchaseDetail');
        // console.log(cachedData)
        // if (cachedData.length > 0 && cachedData ) {
        //   console.log('Fetched from IndexedDB:', cachedData);
        //   setDataSourceState(cachedData);
        //   // return; // Exit early if data is found in cache
        // }
        // setLoadingDataSourceState(true)
        // document.getElementById(`${Id}Grid`).style.opacity = '0 !important'
        const response = await GridDataSource[0].DataSource();
          console.log(response)
          // const response.data.recordset = decryptData(response.data); // Decrypt response

        // console.log('decryptedData',decryptedData)

        const data = response.data.recordset.map((record) => {
          // Object.keys(record).map((key) => {
          //   if (key.toLowerCase().endsWith('date') && record[key]) {
              
          //     record[key] = new Date(record[key].split('T', 1)[0])
          //   }else if(key.toLowerCase().startsWith('isdeleted') || key.toLowerCase().startsWith('isapproved') || key.toLowerCase().startsWith('isclosed')  || key.toLowerCase().startsWith('is') ||  key.toLowerCase().startsWith('transactional') ||  key.toLowerCase().startsWith('inactive') ){
              
          //     // record[key] = record[key] == true ? 'Yes': 'No'
          //     record[key] = record[key] == true ? 'Yes': record[key] == false ? 'No' : record[key]

          //   }else{
          //     console.log(typeof record[key])
          //   }
          // });

          
        console.log("Before:", record);
        Object.keys(record).forEach((key) => {
        
          if (
            key.toLowerCase().startsWith("isdeleted") ||
            key.toLowerCase().startsWith("isapproved") ||
            key.toLowerCase().startsWith("isclosed")
           
          ) {
            record[key] = record[key] === true ? "Yes" : record[key] === false ? "No" : record[key];
          }else if(key.toLowerCase().endsWith("date")){
            
            record[key] = new Date(
              moment(
                typeof record[key] === 'string' && record[key].includes('T')
                  ? record[key].split('T')[0]
                  : record[key]
              )
            );
            // record[key] = new Date(moment(record[key]).format('YYYY-MM-DD'));

            // record[key] =record[key];
          }
        });
          return record
        });
        setLoadingDataSourceState(false)
        console.log(data)
        // allRecordsRef.current = data;
        // const { steps, chunkSize } = findValidStepValue(data.length, STEPS); // Max 20 steps
        // console.log(steps)
        // console.log(chunkSize)
        // CHUNK_SIZE = chunkSize
  
        // setChunkSize(calculatedChunkSize)
        setDataSourceState(data);
       
        console.log(GridDataSource[0].DataSourceIndexName )

        // setCurrentIndex(CHUNK_SIZE);
  
        // Start loading the remaining records in intervals
        // intervalIdRef.current = setInterval(() => {
        //   // loadMoreRecords();
        // }, data.length > 50000 ? 1000 : INTERVAL);
        // setDataSourceState(data);
        // setTimeout(() => {
        //   saveToDB(GridDataSource[0].DataSourceIndexName  ? GridDataSource[0].DataSourceIndexName  : Id ,
        //     data);
        // }, 2000);
        setTimeout(() => {
          // document.getElementById(`${Id}Grid`).style.transition = '0.4'
          // document.getElementById(`${Id}Grid`).style.opacity = '1 !important'
        }, 2000);
      } catch (e) {
        
      }
    } else {
      setTimeout(() => {
            
        setLoadingDataSourceState(false)
      }, 500);
      setDataSourceState([]);
      // accessoryBOMService.getAccessoryBOMForList()
      //   .then((response) => {
          
      //     setDataSourceState(response.data.recordset);
      //   })
      //   .catch((e) => {
          
      //   });
    }
  };
  

  // useEffect(() => {
  // }, []);

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

      let toolbarOptions = ToolbarOption;  // Assign directly from the input
      

  
// Check if toolbarOptions is a string and equals 'All'
if (typeof toolbarOptions === 'string' && toolbarOptions === 'All') {
  // toolbarOptions = ['Add', 'Edit', { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess('MadeupTransferTransactionsDelete') }, 'Update', 'Cancel', 'PDFExport', 'ExcelExport', 'Search', 'ColumnChooser'];
  toolbarOptions = ['Add',
     { text: "Edit", tooltipText: "Edit", id: "Edit", disabled: !SecurityService.canUserAccess(EditSecurity == '' ? `${Id}`:EditSecurity)['Edit'] },
     { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess(DeleteSecurity == '' ? `${Id}`:DeleteSecurity)['Delete'] }, 
    { text: "View", tooltipText: "View", id: "View", disabled: false },
    'Update', 'Cancel', 'PDFExport', 'ExcelExport', 'Search', 'ColumnChooser'];
}
 else if (Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  // Ensure toolbarOptions is an array and run the existing condition
  toolbarOptions = [...toolbarOptions];
  let deleteIndex = toolbarOptions.findIndex(res => res === 'Delete');
  if (deleteIndex !== -1) {
    // toolbarOptions[deleteIndex] = { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess('MadeupTransferTransactionsDelete') };
    toolbarOptions[deleteIndex] = { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess(DeleteSecurity == '' ? `${Id}`:DeleteSecurity)['Delete'] };
  }
  let EditIndex = toolbarOptions.findIndex(res => res == 'Edit');
  if (EditIndex !== -1) {
    toolbarOptions[EditIndex] = { text: "Edit", tooltipText: "Edit", id: "Edit", disabled: typeof EditSecurity === 'boolean' ? EditSecurity :  EditSecurity == ''  ? false : !SecurityService.canUserAccess(EditSecurity == '' ? `${Id}`:EditSecurity)['Edit'] };

  }
  let ViewIndex = toolbarOptions.findIndex(res => res === 'View');
  if (ViewIndex !== -1) {
    // toolbarOptions[ViewIndex] = { text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess('MadeupTransferTransactionsDelete') };
    toolbarOptions[ViewIndex] = { text: "View", tooltipText: "View", id: "View", disabled:  false };
  }
} 

else if (Array.isArray(toolbarOptions) && toolbarOptions.length === 0) {
  toolbarOptions = null;
}
     // Check if AllowPdfExport is false and remove PDFExport from toolbarOptions if present
if (!AllowPdfExport && Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  toolbarOptions = toolbarOptions.filter(option => option !== 'PDFExport');
}

// Check if AllowExcelExport is false and remove ExcelExport from toolbarOptions if present
if (!AllowExcelExport && Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  toolbarOptions = toolbarOptions.filter(option => option !== 'ExcelExport');
} 
if (!ShowColumnChooser && Array.isArray(toolbarOptions) && toolbarOptions.length > 0) {
  toolbarOptions = toolbarOptions.filter(option => option !== 'ColumnChooser');
} 
    
      

  const databound = (AllowDataBound) => {
    setTimeout(()=>{
      
      if (grids.current[Id] && AllowDataBound == true ) {
       
      grids.current[Id].autoFitColumns();
    }
  },200)
  }
 
  const dialogTemplate = (props) => {
    //  { isAdd, GridDialog, dataSourceState } 
    console.log(props)
    
    const { DialogType, Dialog } = GridDialog[0];
    if(DialogType === 'Self'){
    
    var DialogProps = Dialog.props
    var SelfDialog = Dialog.type}
    if (props.isAdd) {
      return DialogType === 'Master' ? (
        <IrtizDynamicInputAdd {...props} dataList={dataSourceState} isView={popupModeTypeView} isAdd={popupModeTypeView == true ? undefined : props.isAdd}/>
      ) : DialogType === 'Self' ? (
        <SelfDialog {...DialogProps} {...props} PrintedByUserName={reduxData.printedByUserName}  dataList={dataSourceState}  selectedRow={selectedRows}
        isView={popupModeTypeView} isAdd={popupModeTypeView == true ? undefined : props.isAdd}
        />

        // <InvoiceEvaluationAdd {...props} dataList={dataSourceState} />
    ): (
        <IrtizDynamicInputAdd {...props} dataList={dataSourceState} isView={popupModeTypeView} isAdd={popupModeTypeView == true ? undefined : props.isAdd} />
      );
    } else {
      return DialogType === 'Master' ? (
        <IrtizDynamicInputAdd {...props} dataList={dataSourceState} isView={popupModeTypeView} isAdd={popupModeTypeView == true ? undefined : props.isAdd} />
      ) : DialogType === 'Self' ? (
        <SelfDialog {...DialogProps} {...props}  dataList={dataSourceState} isView={popupModeTypeView} isAdd={popupModeTypeView == true ? undefined : props.isAdd}/>
      ) : (
        <IrtizDynamicInputAdd {...props} dataList={dataSourceState} isView={popupModeTypeView} isAdd={popupModeTypeView == true ? undefined : props.isAdd}/>
      );
    }
  };
  

  const editSettings: EditSettingsModel = {
    
    // allowEditing: SecurityService.canUserAccess(EditSecurity == '' ? `${Id}Edit`:EditSecurity),
    allowEditing: true,
    allowAdding: SecurityService.canUserAccess(AddSecurity == '' ? `${Id}`:AddSecurity)['Add'],
    allowDeleting: SecurityService.canUserAccess(DeleteSecurity == '' ? `${Id}`:DeleteSecurity)['Delete'],
  //   allowDeleting:true,

  //  allowEditing: true,
  //  allowAdding: true,
    // allowDeleting: true,

    mode: GridEditSettingMode,
    showDeleteConfirmDialog: true,
    headerTemplate:GridEditSettingHeaderTemplate
   };
   if(GridEditSettingMode == 'Dialog'){
    editSettings.template= dialogTemplate;

   }
    
  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    // columns: [
    //   {
    //     field: 'IsDeleted',
    //     operator: 'notequal',
    //     value: 'True'
    //   }
    // ]
    columns: filterState

  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
    columns: groupState,
    sortDirection:DefaultSortedColumnSort
  };

  const footerSum = (e: any) => {
    return <span> Sum: {e.Sum}</span>;
  };


const addUserLog = (inputName ,tableName,tableID,values)=>{
  console.log(inputName,tableName,tableID,values)
  AuditTableInput.auditAdd(inputName,tableName,tableID,values)
}

const editUserLog = (tableName,tableIDValue,selectedRows,values)=>{
  console.log(tableName,tableIDValue,values)
  
  let totalColumns = Object.keys(values);
  console.log(totalColumns)

  AuditTableInput.auditEdit(totalColumns,selectedRows,values,tableName,tableIDValue)
}

  var visibleSortPassFields = useRef([defaultSortColumnName])
  var visibleSortPass = useRef([defaultSortColumnType])
  var ctrlPressed =  useRef(false)
  // var groupingArray = []
  var groupingArray = [...reduxData.gridGroupingOptionsDetails.columns]

  const actionComplete = (args: DialogEditEventArgs) => {
    
    if(args.requestType == "grouping"){
      groupingArray.push(args.columnName)
    }
    if(args.requestType == "ungrouping"){
      groupingArray.splice(groupingArray.indexOf(args.columnName),1)
    }
    ctrlPressed.current = false;
    let handleStore = (e) => {
      e.stopPropagation();
      return  ctrlPressed.current = e.ctrlKey; // Use e.ctrlKey, not e.ctrlkey
    };
    document.addEventListener('keydown', handleStore);
    setTimeout(() => {
      if(args.requestType ==  'sorting'){
        
        setTimeout(() => {
          if(ctrlPressed.current == true ){
            
            if(args.columnName == visibleSortPassFields.current[0] && visibleSortPassFields.current.length == 1){
            }else{
              if(visibleSortPassFields.current.includes(args.columnName)){
                
                visibleSortPass.current[visibleSortPassFields.current.indexOf(args.columnName)] = args.direction;
              }else{
                visibleSortPassFields.current.push(args.columnName)
                visibleSortPass.current.push(args.direction)
              }
            }
            setTimeout(() => {
              return ctrlPressed.current = false;
            }, 200);
          }else{
            
            visibleSortPassFields.current =[args.columnName]
            visibleSortPass.current = [args.direction]
          }
        }, 80);
        
        setTimeout(() => {
          
          
          
          
        }, 300);
      }
    }, 200);
    if(args.requestType == 'filtering'  && args.action == 'filter'){
      let filterArray = [...filterColumnName , args.currentFilteringColumn]
      filterColumnName = filterArray.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    }
    
    if (args?.requestType === 'columnstate') {
      
      grids.current[Id]?.autoFitColumns();
    }
    if(args.requestType == 'filtering'  && args.action == "clear-filter"){
      if(recordColumnName.includes(args.currentFilteringColumn)){
        
        recordColumnName.splice(recordColumnName.indexOf(args.currentFilteringColumn),1)
        
        fiterCheckedValue.splice(recordColumnName.indexOf(args.currentFilteringColumn),1)
        if(filterColumnName.includes(args.currentFilteringColumn) ){
          filterColumnName.splice(filterColumnName.indexOf(args.currentFilteringColumn),1)
        }
      }
      
    }
    if(args.requestType == 'filtering'  && args.action == 'filter'){
      
      if(!recordColumnName.includes(args.currentFilteringColumn)){
        const filteredData = grids.current[Id].getFilteredRecords();
        let checkedValue   = filteredData.map((val)=>{ return val[args.currentFilteringColumn]}).filter((value, index, self) => { return self.indexOf(value) === index })
        recordColumnName = [...recordColumnName , args.currentFilteringColumn]
        fiterCheckedValue = [...fiterCheckedValue , checkedValue]
      }else{
        
        fiterCheckedValue.splice(recordColumnName.indexOf(args.currentFilteringColumn) , 1)
        const filteredData = grids.current[Id].getFilteredRecords();
        let checkedValue   = filteredData.map((val)=>{ return val[args.currentFilteringColumn]}).filter((value, index, self) => { return self.indexOf(value) === index })
        fiterCheckedValue = [...fiterCheckedValue , checkedValue]
        
      } 
    }
    if (args.form) {
      if(args.requestType == 'save'){

        popupModeTypeView = false
      }
      ListActionComplete(
        grids.current[Id] ,
        args,
        getListService ,
        selectedRows ,
        setDataSourceState,
        addUserLog,
        editUserLog
      )
      
      
      
      
    }}
    
    // const commandClick = (args: CommandClickEventArgs) => {
      //   setShowDialog(false);
      //   
      //   setSelectedRow(args.rowData);
      //   setShowDialog(true);
      // };
      
      // const commands: CommandModel[] = [
        //   {
          //     buttonOption: {
            //       content: 'Delivery Schedule',
            //       cssClass: 'e-flat',
            //     },
            //   },
            // ];
            
            // const dialogClose = () => {
              //   this.buttonInstance.style.display = 'inline-block';
              //   setShowDialog(false);
  // };

  

  

  const userId = SecurityService.getLoggedInUserId();
  const getFieldFormat = (fields, fieldName) => {
    const fieldObj = fields.find(field => field.field === fieldName);
    if (!fieldObj) return undefined;
  
    const otherObj = fieldObj.other?.find(item => item.format);
    return otherObj ? otherObj.format : undefined;
  };
 // DYNAMIC TEMPLATE CODE
 const GridSum = (GridSumColumns , ColumnsList)=>{



  // Initialize gridSum as an empty array
let gridSum = [];
if(AllowGridSum  == true){
if (GridSumColumns.length > 0) {
  // Map over GridSumColumns to set format based on conditions
  gridSum = GridSumColumns.map((column) => {
    if (column.includes('Rate') || column.endsWith('Percent')) {
      return {
        field: column,
        format:  getFieldFormat(ColumnsList,column) || 'n2', // Format for rate or percent
      };
    } else {
      return {
        field: column,
        format:  getFieldFormat(ColumnsList,column) || 'n0', // Default format
      };
    }
  });
} else {
  // If GridSumColumns is empty, map over ColumnsList
  gridSum = ColumnsList.map((column) => {
    // Check if format is defined in other[0]
    if (column.other[0]?.format) {
      return {
        field: column.field,
        format: column.other[0].format,
      };
    }
  }).filter((result) => result !== undefined); // Filter out undefined results
}
}else{
  gridSum = [
    // {
    //   field:'dontmakesum',
    //   format: 'n0',
    // }
  ]
}
// Log the resulting gridSum array

console.log(gridSum)
return gridSum.length > 0 ?(

  
  <AggregatesDirective>

  <AggregateDirective>
    <AggregateColumnsDirective>
      {/* {gridSum.length > 0  ?
      (gridSum.map(res=>{
      return(<AggregateColumnDirective field={res.field} type='Sum' format={res.format} footerTemplate={footerSum} />)
      })
      ):null
  } */}
   {
gridSum.map(res=>{
return(<AggregateColumnDirective field={res.field} type='Sum' format={res.format} footerTemplate={footerSum} />)
})}
    </AggregateColumnsDirective>
  </AggregateDirective>

  <AggregateDirective>
    <AggregateColumnsDirective>
    {
gridSum.map(res=>{
return(<AggregateColumnDirective field={res.field} type='Sum' format={res.format} groupFooterTemplate={footerSum} />)
})}
  {/* {gridSum.length > 0  ?
      (gridSum.map(res=>{
      return(<AggregateColumnDirective field={res.field} type='Sum' format={res.format} footerTemplate={footerSum} />)
      })
      ):null
  } */}
      
     

    </AggregateColumnsDirective>
  </AggregateDirective>

</AggregatesDirective>
) :null
 }
 const onClosing = (e)=>{
  console.log(e);
  // grids.current[Id].refresh();
  getListService();
 }
 const CommandClick = (args: CommandClickEventArgs) => {
  console.log(args)
  if (args.commandColumn.buttonOption.id === 'FabricReq') {
    // setShowDialogImport(false);
    // setSelectedRow(args.rowData);
    // setShowDialogImport(true);
    // return (<AddNewDialog 
    // Route={'Brand'} 
    // Security={'YarnBrandList'} 
    // onClosed={onClosing} 
    // RefName={'FabricReq'}
    // />)
  } else if (args.commandColumn.buttonOption.id === 'Projection') {
    // setShowDialogProjection(false);
    // console.log('command click args: ', args);
    // setSelectedRow(args.rowData);
    // setShowDialogProjection(true);
  }
  
};

console.log(reduxData.gridGroupingOptionsDetails)

 const ListGridComponent = ({ restrictPageSize = 12 }) => {
  
  const handleGridRef = (grid) => {
    if (grid) {
      grids.current[Id] = grid;
    }
  };
  const columns = useMemo(() => {
    // Determine the appropriate column list based on IsDialog
    const sourceColumns = IsDialog ? ColumnsList : reduxData.gridColumnsListWithDetails;
  
    const updatedColumns = sourceColumns.map((column) => {
      if (column.field.endsWith('Date')) {
        return {
          ...column,
          other: [{ ...column.other[0], format: formatOptions }],
        };
      } else if (
        
        column.field.toLowerCase().startsWith('isdeleted') || column.field.toLowerCase().startsWith('isapproved') || column.field.toLowerCase().startsWith('isclosed')  || column.field.toLowerCase().startsWith('is')
      ) {
        return {
          ...column,
          other: [
            {
              ...column.other[0],
              template: (props) => (  
                <p style={{ margin: '0px' }}>
                  {props[column.field] === true ? 'Yes' :props[column.field] === false ? 'No': props[column.field]}
                </p>
              ),
            },
          ],
        };
      }
    
      return column;
    });
  
    // Determine the data source length based on IsDialog
    const dataSourceLength = IsDialog ? dataSourceState.length : reduxData.gridColumnsListWithDetails.length;
  
    if (dataSourceLength > 0) {
      return updatedColumns.map((field, index) => {
        if (field.field === 'Commands') {
          return (
            <ColumnDirective
              key={index} // Use index as a key if a unique key is not available
              headerText={field.headerText}
              width={field.width}
              template={(args) => {
                console.log(args)
                return (
                    <div style={{
                      gap: '10px',
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                      width:field.width
                  }}>
                        {field.other[0].button.map((btn, index) => (
                            <DialogInput
                                key={index} // Use a unique key for each button
                                Route={btn?.Input?.Route}
                                Security={btn?.Input?.Security}
                                OnClosed={onClosing}
                                Title={btn?.Content} // Use the dynamic title from the button object
                                InputTitle={btn?.Input?.Title} // Use the dynamic input title from the button object
                                Width={btn?.Input?.Width} // Use the dynamic input title from the button object
                                SelectedRow={args}
                                BgColor={btn?.BgColor}
                                Color={btn?.Color}
                            />
                        ))}
                    </div>
                );
            }}
            
              headerTextAlign={field.headerTextAlign}
              textAlign={field.textAlign}
              {...field.other[0]}
              // direction={visibleSort[index]}
            />
          );
        } else {
          return (
            <ColumnDirective
              key={field.field}
              headerText={field.headerText}
              id={field.field}
              field={field.field}
              width={field.width}
              headerTextAlign={field.headerTextAlign}
              textAlign={field.textAlign}
              {...field.other[0]}
              // direction={visibleSort[index]}
            />
          );
        }
      });
    } else {
      return <ColumnDirective field="IsDeleted" visible={false} />;
    }
  }, [IsDialog, ColumnsList, reduxData.gridColumnsListWithDetails, formatOptions ]);
  
return (
    <GridComponent
          // ref={(grid) => (grids.current[Id] = grid)}
          ref={handleGridRef}

          id={`${Id}Grid`}
          dataSource={dataSourceState}
          editSettings={editSettings}
          pageSettings={{ pageCount: 4, pageSizes: true, pageSize: restrictPageSize }}
          toolbar={toolbarOptions}
          toolbarClick={toolbarClick}
          allowExcelExport={AllowExcelExport}
          allowPdfExport={AllowPdfExport}
          showColumnChooser={ShowColumnChooser}
          allowPaging={AllowPaging}
          allowGrouping={IsDialog == true ? false : AllowGrouping}

          
          // commandClick={CommandClick}
          filterSettings={filterOptions}
          // groupSettings={groupOptions}
          groupSettings={ AllowTemplate == false ? groupOptions : groupOptions
            // {
            //   showDroopArea: true,
            //   columns: reduxData.gridGroupingOptionsDetails || groupState,
            //   sortDirection:DefaultSortedColumnSort
            // }
            }

          actionComplete={actionComplete}
          allowTextWrap='true'
          
          allowSorting={true}
          allowFiltering={true}
          allowReordering={true}
          allowResizing={true}
          sortSettings={    IsDialog || AllowTemplate == false ?
                { columns:[{ field: defaultSortColumnName, direction: defaultSortColumnType }]}
    :
          reduxData.gridSortingOptionsDetails}
          dataBound={databound(AllowDataBound)}
          rowDataBound={rowDataBound}
          rowSelected={
            (args)=>{
              console.log(args)
              
              selectedRows = args.data
              ToolbarClicking(grids.current[Id], args ,args.data,getListService,setDataSourceState)
              
                        setTimeout(() => {
                
              }, 200);
            }
          }
          rowDeselected={
            (args)=>{
              console.log(args)
              ToolbarClicking(grids.current[Id], args ,args.data ,getListService,setDataSourceState)
              selectedRows = []
            }
          }
        >
            <ColumnsDirective>
            
          {columns}
            </ColumnsDirective>
         {   GridSum( GridSumColumns, ColumnsList )}

          <Inject
            services={[
              Edit,
              Toolbar,
              Page,
              Sort,
              PdfExport,
              ExcelExport,
              Filter,
              Group,
              Aggregate,
              Freeze,
              ColumnChooser,
              Reorder,
              Resize,
              CommandColumn,
            ]}
          />
        </GridComponent>

)
};

// DYNAMIC TEMPLATE CODE
  const getColumnsDetail = ()=>{
    return grids.current[Id].getColumns()
  }

return (
    <div id='dialog-container' className={IsDialog == false?`content-wrapper`:''}>
      <div>
            <div>
      {IsDialog == true ? (<></>):(<>
              <h3>{
                ListTitle
                }
              {/* // DYNAMIC TEMPLATE CODE */}
              {AllowTemplate == true ? <button 
              onClick={(e)=>{ 
                e.preventDefault();
                
                setIsToggled(!isToggled)
                setTimeout(() => {
                  
                  ToolbarClicking(grids.current[Id], {name:isToggled ? "TemplateClosed" : "TemplateOpened"} ,selectedRows.length == 0 ?  undefined : selectedRows
                  , getListService,setDataSourceState
                  )
                }, 1000);
              }}
              className={`toggle-templete ${isToggled ? 'active' : ''}`}
              >
       {ToggledValue}               
          </button >:null }
          {/* isToggled ,
  ColumnProps ,
  getListService ,
  getColumns , 
  InputListSecurity ,
  visibleSortPassFields ,
  visibleSortPass ,
  groupingArray ,
  defaultSortColumnName ,
  defaultSortColumnType */}
              </h3> </>)}
              {IsDialog == true  || AllowTemplate == false ? (<></>):(<>
              <TemplateCode
               isToggled={isToggled}
               ColumnProps={columnData}
               getListService={getListService}
               getColumns={getColumnsDetail}
               InputListSecurity={InputListSecurity}
               visibleSortPassFields={visibleSortPassFields}
               visibleSortPass={visibleSortPass}
               groupingArray={groupingArray}
               defaultSortColumnName={defaultSortColumnName}
               defaultSortColumnType={defaultSortColumnType}
               isHaveFilterColumn={FilterColumns.length > 0 && FilterColumns[0].field == 'IsDeleted'? true : false}

               />      
               </>)}
              <div>
              </div>
             
              {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                setTimeout(() => {
                        
                  getListService();
              }, 200);
    }
              }} 
                ></HardDelete>
                  :null}
            {
            loadingdataSourceState == false ?  
            <ListGridComponent />
              :                 
              <div className='loader-div'> <img src={imgSrc} id='' /> LOADING...</div>
            }
          </div>
            </div>
          </div>
  );
}





